/**
 * The old comparison address, `/services/:id/testing/compare?a=&b=` (task
 * 1178). Compare is a section of the Testing tab since task 1227, so this
 * route only forwards to `?tab=testing&section=compare` with `a` and `b`, and
 * every link and bookmark made before keeps working. The route keeps its flags
 * (`innovate.fe.testing.compare.page` and `innovate.fe.testing.runs`).
 */
import { Navigate, useParams, useSearchParams } from 'react-router-dom';

export function TestComparisonPage() {
  const { id: endpointId } = useParams<{ id: string }>();
  const [params] = useSearchParams();
  const next = new URLSearchParams({ tab: 'testing', section: 'compare' });
  for (const side of ['a', 'b'] as const) {
    const value = params.get(side);
    if (value) next.set(side, value);
  }
  return <Navigate to={`/services/${endpointId}?${next.toString()}`} replace />;
}

export default TestComparisonPage;
